// extracted by mini-css-extract-plugin
module.exports = {"media":"[slug]_media_2HaO0"};